import { useApi } from "@utils/useApi";
import { EcommerceShoppingCartClient } from "@lib/ShiOneClient";
import { useQuery } from "@tanstack/react-query";
import ms from "ms";
import { CART_PRODUCT_THUMBNAILS_QUERY_KEY } from "@features/unified-user-header-feature/utils/HeaderQueryKeys";

/**
 * Fetches thumbnail image URLs for the supplied cart product ids (ShoppingCartDto.itemId).
 * Enabled only when the dialog is open and there is at least one id. Look up a url with
 * `data?.[String(itemId)]`; a missing key means "no image" (use a placeholder).
 */
export const useGetCartProductThumbnails = (
  itemIds: number[],
  enabled: boolean,
) => {
  const api = useApi(EcommerceShoppingCartClient);
  const ids = [...new Set(itemIds)].sort((a, b) => a - b);

  return useQuery({
    queryKey: [CART_PRODUCT_THUMBNAILS_QUERY_KEY, ids],
    queryFn: () => api.getCartItemThumbnails(ids),
    enabled: enabled && ids.length > 0,
    staleTime: ms("10m"),
  });
};

export default useGetCartProductThumbnails;
